import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_VERSION } from '@/modules/version/router';
import versionService from '@/services/version';
import useVuelidate from '@vuelidate/core';
import { helpers, or, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useVersionEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        store: 0,
        version: '',
        assetLink: '',
        releasedDate: null,
        canEditReleasedDate: false
    });

    const validations = {
        assetLink: { required },
        releasedDate: {
            validDate: helpers.withMessage(
                `Value must be greater than current time`,
                or(() => !model.canEditReleasedDate, validateDateAfter())
            )
        }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => versionService.get(model.id),
        onSuccess: ({ data }) => {
            data.releasedDate = data.releasedDate ? new Date(data.releasedDate) : null;
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_VERSION.INDEX, query: { store: model.store } })
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () => {
            const newReleasedDate =
                model.releasedDate && model.canEditReleasedDate ? model.releasedDate.getTime() : null;
            return versionService.update(model.id, model.assetLink, newReleasedDate);
        },
        onSuccess: () => router.push({ name: ROUTE_NAME_VERSION.INDEX, query: { store: model.store } })
    });

    return { model, v$, update, fetch };
}
